export default __webpack_public_path__ + "static/pc-carousel-07-7a7894375d875dcd6fd5dffdf698a28e.jpg";